import { render, staticRenderFns } from "./unpakt.vue?vue&type=template&id=967bb808&scoped=true&"
import script from "./unpakt.vue?vue&type=script&lang=js&"
export * from "./unpakt.vue?vue&type=script&lang=js&"
import style0 from "./unpakt.vue?vue&type=style&index=0&id=967bb808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967bb808",
  null
  
)

export default component.exports